import { DefaultError } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { ftpConnectionInitialValue } from 'components/organisms/forms/ftp-connection/FtpConnectionForm';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold, PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteProviderFtpConnection,
  useGetProviderFtpConnection,
} from 'services/providers/ftp';
import { onErrorShowToast } from 'utils/service/errorHandler';

const FtpConnection = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const navigate = useNavigate();
  const ftpConnection = useGetProviderFtpConnection(providerId, salesChannelId);
  const { t } = useTranslation();

  const removeFtpConnection = useDeleteProviderFtpConnection();

  const onRemove = async (actions: PopupActions) => {
    await removeFtpConnection.mutateAsync(
      { providerId, salesChannelId },
      {
        onError: (error: DefaultError) => {
          actions.close();
          onErrorShowToast(error);
        },
        onSuccess: () => navigate(`/settings/provider/${providerId}`),
      }
    );
  };

  return (
    <Form.FtpConnection
      i18nextPrefix=''
      initialValues={
        ftpConnection.data ? ftpConnection.data : ftpConnectionInitialValue
      }
      onSubmit={() => {}}
      status={{ displayMode: true, isLoading: ftpConnection.isLoading }}
      backPath={`/settings/provider/${providerId}`}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(`/settings/provider/${providerId}`);
          }}>
          <Button.Description description={t('button.back')} />

          <Button.Icon icon={<PiCaretLeftBold />} />
        </Button>
      }
      topbarContent={
        <div className='flex justify-end'>
          {!ftpConnection.data?.isPredefined && (
            <Button
              isClear
              onlyIcon
              onClick={() => {
                navigate(
                  `/settings/provider/${providerId}/ftp-connection/edit/${salesChannelId}/keys`,
                  {
                    replace: true,
                  }
                );
              }}>
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}

          {!ftpConnection.data?.isPredefined && (
            <MagellanPopups.DeleteWarning onRemove={onRemove} />
          )}
        </div>
      }
    />
  );
};

export default FtpConnection;
